import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";
import { isOnline } from "./syncService";

// Servicio para sincronizar los datos de la empresa desde Business Central

export const syncEmpresa = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        console.log("Sincronizando información de empresa...");

        // Obtener datos de empresa desde Business Central
        const serverEmpresa = await fetchFromBusinessCentral("Empresa");

        if (!serverEmpresa || serverEmpresa.length === 0) {
            console.warn("No se encontraron datos de empresa en Business Central");
            return false;
        }

        // Tomar el primer elemento del array (según especificación del usuario)
        const empresaData = serverEmpresa[0];

        // Verificar si ya existe información de empresa
        const existingEmpresa = await db.empresa.orderBy('id').first();

        if (existingEmpresa) {
            // Actualizar información existente
            await db.empresa.update(existingEmpresa.id, {
                Primary_Key: empresaData.Primary_Key || "",
                Name: empresaData.Name || "",
                Address: empresaData.Address || "",
                Address_2: empresaData.Address_2 || "",
                City: empresaData.City || "",
                County: empresaData.County || "",
                Post_Code: empresaData.Post_Code || "",
                SAT_Postal_Code: empresaData.SAT_Postal_Code || "",
                Country_Region_Code: empresaData.Country_Region_Code || "",
                Contact_Person: empresaData.Contact_Person || "",
                Phone_No: empresaData.Phone_No || "",
                VAT_Registration_No: empresaData.VAT_Registration_No || "",
                Federal_ID_No: empresaData.Federal_ID_No || "",
                EORI_Number: empresaData.EORI_Number || "",
                Industrial_Classification: empresaData.Industrial_Classification || "",
                Registration_No: empresaData.Registration_No || "",
                Phone_No_2: empresaData.Phone_No_2 || "",
                Fax_No: empresaData.Fax_No || "",
                E_Mail: empresaData.E_Mail || "",
                Home_Page: empresaData.Home_Page || "",
                Identificación_del_Rep_Legal: empresaData.Identificación_del_Rep_Legal || "",
                RUC_del_Contador: empresaData.RUC_del_Contador || "",
                Cod_contribuyente_especial: empresaData.Cod_contribuyente_especial || "",
                Código_otorgado_por_DINARDAP: empresaData.Código_otorgado_por_DINARDAP || "",
                No_Establecimientos_inscritos: empresaData.No_Establecimientos_inscritos || 0,
                Auto_E_Invoice: empresaData.Auto_E_Invoice || false,
                Bank_Name: empresaData.Bank_Name || "",
                Bank_Branch_No: empresaData.Bank_Branch_No || "",
                Bank_Account_No: empresaData.Bank_Account_No || "",
                Payment_Routing_No: empresaData.Payment_Routing_No || "",
                Giro_No: empresaData.Giro_No || "",
                SWIFT_Code: empresaData.SWIFT_Code || "",
                IBAN: empresaData.IBAN || "",
                Ship_to_Name: empresaData.Ship_to_Name || "",
                Ship_to_Address: empresaData.Ship_to_Address || "",
                Ship_to_Address_2: empresaData.Ship_to_Address_2 || "",
                Ship_to_City: empresaData.Ship_to_City || "",
                Ship_to_County: empresaData.Ship_to_County || "",
                Ship_to_Post_Code: empresaData.Ship_to_Post_Code || "",
                Ship_to_Country_Region_Code: empresaData.Ship_to_Country_Region_Code || "",
                Ship_to_Phone_No: empresaData.Ship_to_Phone_No || "",
                Ship_to_Contact: empresaData.Ship_to_Contact || "",
                Ship_to_UPS_Zone: empresaData.Ship_to_UPS_Zone || "",
                Location_Code: empresaData.Location_Code || "",
                Responsibility_Center: empresaData.Responsibility_Center || "",
                Check_Avail_Period_Calc: empresaData.Check_Avail_Period_Calc || "",
                Check_Avail_Time_Bucket: empresaData.Check_Avail_Time_Bucket || "",
                Base_Calendar_Code: empresaData.Base_Calendar_Code || "",
                Customized_Calendar: empresaData.Customized_Calendar || "",
                Cal_Convergence_Time_Frame: empresaData.Cal_Convergence_Time_Frame || "",
                QST_Registration_No: empresaData.QST_Registration_No || "",
                Tax_Area_Code: empresaData.Tax_Area_Code || "",
                Tax_Exemption_No: empresaData.Tax_Exemption_No || "",
                Tax_Scheme: empresaData.Tax_Scheme || "",
                SAT_Tax_Regime_Classification: empresaData.SAT_Tax_Regime_Classification || "",
                Provincial_Tax_Area_Code: empresaData.Provincial_Tax_Area_Code || "",
                RFC_Number: empresaData.RFC_Number || "",
                CURP_No: empresaData.CURP_No || "",
                State_Inscription: empresaData.State_Inscription || "",
                Software_Identification_Code: empresaData.Software_Identification_Code || "",
                GLN: empresaData.GLN || "",
                Use_GLN_in_Electronic_Document: empresaData.Use_GLN_in_Electronic_Document || false,
                Allow_Blank_Payment_Info: empresaData.Allow_Blank_Payment_Info || false,
                BankAccountPostingGroup: empresaData.BankAccountPostingGroup || "",
                Company_Badge: empresaData.Company_Badge || "",
                System_Indicator_Style: empresaData.System_Indicator_Style || "",
                System_Indicator_Text: empresaData.System_Indicator_Text || "",
                Experience: empresaData.Experience || "",
                lastSynced: new Date(),
                lastModified: new Date()
            });

            console.log("Información de empresa actualizada correctamente");
        } else {
            // Crear nueva información de empresa
            await db.empresa.add({
                Primary_Key: empresaData.Primary_Key || "",
                Name: empresaData.Name || "",
                Address: empresaData.Address || "",
                Address_2: empresaData.Address_2 || "",
                City: empresaData.City || "",
                County: empresaData.County || "",
                Post_Code: empresaData.Post_Code || "",
                SAT_Postal_Code: empresaData.SAT_Postal_Code || "",
                Country_Region_Code: empresaData.Country_Region_Code || "",
                Contact_Person: empresaData.Contact_Person || "",
                Phone_No: empresaData.Phone_No || "",
                VAT_Registration_No: empresaData.VAT_Registration_No || "",
                Federal_ID_No: empresaData.Federal_ID_No || "",
                EORI_Number: empresaData.EORI_Number || "",
                Industrial_Classification: empresaData.Industrial_Classification || "",
                Registration_No: empresaData.Registration_No || "",
                Phone_No_2: empresaData.Phone_No_2 || "",
                Fax_No: empresaData.Fax_No || "",
                E_Mail: empresaData.E_Mail || "",
                Home_Page: empresaData.Home_Page || "",
                Identificación_del_Rep_Legal: empresaData.Identificación_del_Rep_Legal || "",
                RUC_del_Contador: empresaData.RUC_del_Contador || "",
                Cod_contribuyente_especial: empresaData.Cod_contribuyente_especial || "",
                Código_otorgado_por_DINARDAP: empresaData.Código_otorgado_por_DINARDAP || "",
                No_Establecimientos_inscritos: empresaData.No_Establecimientos_inscritos || 0,
                Auto_E_Invoice: empresaData.Auto_E_Invoice || false,
                Bank_Name: empresaData.Bank_Name || "",
                Bank_Branch_No: empresaData.Bank_Branch_No || "",
                Bank_Account_No: empresaData.Bank_Account_No || "",
                Payment_Routing_No: empresaData.Payment_Routing_No || "",
                Giro_No: empresaData.Giro_No || "",
                SWIFT_Code: empresaData.SWIFT_Code || "",
                IBAN: empresaData.IBAN || "",
                Ship_to_Name: empresaData.Ship_to_Name || "",
                Ship_to_Address: empresaData.Ship_to_Address || "",
                Ship_to_Address_2: empresaData.Ship_to_Address_2 || "",
                Ship_to_City: empresaData.Ship_to_City || "",
                Ship_to_County: empresaData.Ship_to_County || "",
                Ship_to_Post_Code: empresaData.Ship_to_Post_Code || "",
                Ship_to_Country_Region_Code: empresaData.Ship_to_Country_Region_Code || "",
                Ship_to_Phone_No: empresaData.Ship_to_Phone_No || "",
                Ship_to_Contact: empresaData.Ship_to_Contact || "",
                Ship_to_UPS_Zone: empresaData.Ship_to_UPS_Zone || "",
                Location_Code: empresaData.Location_Code || "",
                Responsibility_Center: empresaData.Responsibility_Center || "",
                Check_Avail_Period_Calc: empresaData.Check_Avail_Period_Calc || "",
                Check_Avail_Time_Bucket: empresaData.Check_Avail_Time_Bucket || "",
                Base_Calendar_Code: empresaData.Base_Calendar_Code || "",
                Customized_Calendar: empresaData.Customized_Calendar || "",
                Cal_Convergence_Time_Frame: empresaData.Cal_Convergence_Time_Frame || "",
                QST_Registration_No: empresaData.QST_Registration_No || "",
                Tax_Area_Code: empresaData.Tax_Area_Code || "",
                Tax_Exemption_No: empresaData.Tax_Exemption_No || "",
                Tax_Scheme: empresaData.Tax_Scheme || "",
                SAT_Tax_Regime_Classification: empresaData.SAT_Tax_Regime_Classification || "",
                Provincial_Tax_Area_Code: empresaData.Provincial_Tax_Area_Code || "",
                RFC_Number: empresaData.RFC_Number || "",
                CURP_No: empresaData.CURP_No || "",
                State_Inscription: empresaData.State_Inscription || "",
                Software_Identification_Code: empresaData.Software_Identification_Code || "",
                GLN: empresaData.GLN || "",
                Use_GLN_in_Electronic_Document: empresaData.Use_GLN_in_Electronic_Document || false,
                Allow_Blank_Payment_Info: empresaData.Allow_Blank_Payment_Info || false,
                BankAccountPostingGroup: empresaData.BankAccountPostingGroup || "",
                Company_Badge: empresaData.Company_Badge || "",
                System_Indicator_Style: empresaData.System_Indicator_Style || "",
                System_Indicator_Text: empresaData.System_Indicator_Text || "",
                Experience: empresaData.Experience || "",
                lastSynced: new Date(),
                lastModified: new Date()
            });

            console.log("Información de empresa creada correctamente");
        }

        return true;
    } catch (error) {
        console.error("Error al sincronizar información de empresa:", error);
        return false;
    }
}; 